import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsWinmateComponent } from './simple-icons-winmate.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsWinmateComponent ],
    exports:      [ SimpleIconsWinmateComponent ],
    bootstrap:    []
})
export class SimpleIconsWinmateModule {}
